<template>
  <div class="table-fixed-box">
    <div class="fixed-box-list" ref="fixed-box" v-loading="loading">
      <div class="table-line-head is-top-fixed" ref="table-line-head" v-if="(taskList.unArch.length > 0 || taskList.arch.length > 0) && autoKey">
        <div class="table-line-head-in" ref="table-line-head-in">
          <div class="table-line-tr" :style="{ width: lineBox.width + 'px' }" ref="table-line-tr" :key="lineBox.key">
            <span>{{ lineBox.title }}</span>
          </div>
          <div class="table-line-tr is-auto-key" ref="table-line-tr" v-for="item in templateKey" :key="item.key" @mousemove="autoKeyTrMove($event, item)" @mouseleave="autoKeyTrLevel($event, item)" @mousedown="autoKeyTrDown($event, item)" @mouseup="autoKeyTrUp(item)" :style="{ 'min-width': item.width + 'px' }" :data-width="setWidth(item)">
            <toolTip :title="item.component_name_in_template" :maxWidth="'100%'">
              <span>{{ item.component_name_in_template }}</span>
            </toolTip>
            <!-- 表头筛选 -->
            <div class="table-sort-down">
              <el-dropdown trigger="click" v-if="item.is_sort">
                <span class="el-dropdown-link">
                  <i class="icon iconfont tableIconHover" :class="item.getIcon ? item.getIcon() : ''"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="filter-status-dropdown">
                  <el-dropdown-item
                  v-for="temp in item.sort"
                  :key="temp.value"
                  :command="temp.value"
                  @click.native="selectSort(item.component_name_in_template, temp.value)"
                  >
                  <toolTip :title="temp.label"><span>{{temp.label}}</span></toolTip>
                    <i class="icon iconfont iconicon_selected_more_task" v-show="item.sort_value === temp.value"></i>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div v-if="taskList.unArch.length > 0 || taskList.arch.length > 0" class="outer-box" ref="outer-box" @scroll="addListenerScroll($event)">
        <!-- 遮罩层 -->
        <div class="check-box" v-for="(item,index) in checkBox" :key="index" :style="{ 'width': followHeadWidth + 'px', 'top': item.top + 'px' }"></div>
        <div class="taskSuper-table" id="taskSuper-table" ref="taskSuper-table">
          <div class="table-line-content" ref="table-line-content">
            <div class="fo-header" :style="{ 'width': lineBox.width + 'px'}" v-sticky="{ zIndex: 1001, stickyTop: 0}">
              <div class="fo-header-in">
                <div class="up-arrow" @click="closeArchOrClose('unArch')">
                  <i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': !taskList.unArchClose}"></i>
                </div>
                <p>未归档父任务</p>
              </div>
            </div>
            <div ref="table-body" class="table-body" :style="taskList.unArchClose ? 'display: none;' : ''">
              <vuedraggable  handle=".group-drag-box-icon" element="div" v-bind="dragOptionsList()" @update="endList" :list="taskList.unArch" >
                <div class="table-line---title" ref="table-line---title" :data-index="index" :class="{ 'close-box': list.close }" v-for="(list, index) in taskList.unArch" :key="list.id">
                  <div class="task-name" ref="task-name" :style="{ 'width': lineBox.width + 'px' }">
                    <div class="task-name-in" ref="task-name-in" :data-id="list.id" :data-index="index" :style="{ 'width': lineBox.width + 'px' }">
                      <el-tooltip class="task-name-fo" effect="dark" :content="list.check ? '取消全选': '全选'" placement="top" v-if="isCheckStatus && getKeyList(list.tasks).length > 0">
                        <el-checkbox class="fo-all-check--checkbox"  :indeterminate="list.indeterminate" :value="list.check" @change="checkBoxChange(list, getKeyList(list.tasks))"></el-checkbox>
                      </el-tooltip>
                      <div  class="group-drag-box-icon">
                        <i v-if="hasPermission && !list.isTitleEdit && !isCheckStatus && !ganttType && !isDisabledProject" class="icon iconfont iconicon_drag_order tableIconHover drag-icon"></i>
                      </div>
                      <div class="up-arrow" :style="{ visibility: list.unarchived_parent_task_count > 0 ? 'visible' : 'hidden' }" @click="closeItem(index, 'unArch')">
                        <i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': !list.close}"></i>
                      </div>
                      <div class="taskList-title" v-if="!list.isTitleEdit">
                        <toolTip :title="list.title" :maxWidth="'calc(100% - 60px)'" @click.native="editTitle(list,`inputs-unArch-${list.task_list_id}`)">
                          <span>{{ list.title }}</span>
                        </toolTip>
                        <div class="count">{{ list.unarchived_completed_parent_task_count }}/{{ list.unarchived_parent_task_count }}</div>
                      </div>
                      <div v-else class="title-input">
                        <el-input :ref="`inputs-unArch-${list.task_list_id}`" v-model="list.title" @blur="changeTitle(list)" @keyup.enter.native="enterTitleChange(`inputs-unArch-${list.task_list_id}`)"></el-input>
                      </div>
                      <div class="tasklist-title-right" v-if="!ganttType && !isDisabledProject">
                        <div class="icon-heand-tool" v-if="!list.isTitleEdit">
                          <el-dropdown trigger="click"  @visible-change="changeListShow(list)" v-if="hasPermission && !list.isTitleEdit && !isCheckStatus">
                            <i
                            class="icon iconfont iconicon_more_task1 tableIconHover more-icon"
                            :class="{'visibleActive': list.titleShow}"
                            ></i>
                            <el-dropdown-menu slot="dropdown" :offset="0" class="tasklist-title-more">
                              <el-dropdown-item @click.native="delGroup(list)">
                                <i class="icon iconfont iconicon_recycle_bin"></i>
                                <span>移至回收站</span>
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                        <i v-if="!isCheckStatus" class="icon iconfont iconicon_enlarge tableIconHover add-icon" @click="addTask(list)"></i>
                      </div>
                    </div>
                  </div>
                  <template v-for="(val, key) in list.tasks">
                    <TrList v-if="typeof val === 'object'" :key="key" :list="val" :lineBox="lineBox" :pageMsg="pageMsg" :group="list.task_list_id" :taskList="taskList.unArch" :pid="''" :activeId="activeId" :autoKey="autoKey" :projectId="projectId" :sortList="sortList" :templateKey="templateKey" :groupKey="key" @check="check(getKeyList(list.tasks), list)" :headerWidth="followHeadWidth"></TrList>
                  </template>
                  <div class="table-footer-count-box" v-if="!list.close && getKeyList(list.tasks).length > 0 && autoKey">
                    <div class="table-footer-count">
                      <div class="table-footer-count---item table-line-item---in--fixed" :style="{ width: lineBox.width + 'px' }">
                        <span>记录总数</span><span class="task-number-val">{{ taskCountChildren(list.tasks) }}</span>
                      </div>
                      <div class="table-footer-count---item table-line-item---in--not" :style="{ width: lineBox.width + 'px' }"></div>
                      <div class="table-footer-count---item" v-for="(val, key) in templateKey" :key="key" :data-id="key" :style="{'min-width': val.width + 'px'}">
                        <TableModeCount :dataset="getKeyList(list.tasks)" :code="val.component_code || val.code" :id="val.id"></TableModeCount>
                      </div>
                    </div>
                  </div>
                </div>
              </vuedraggable>
            </div>
            <div class="fo-header arch"  v-sticky="{ zIndex: 1001, stickyTop: 50}">
              <div class="fo-header-in" :style="{ 'width': lineBox.width + 'px'}">
                <div class="up-arrow" @click="closeArchOrClose('arch')">
                  <i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': !taskList.archClose}"></i>
                </div>
                <p>已归档父任务</p>
              </div>
            </div>
            <div ref="table-body" class="table-body table-body-arch" :style="taskList.archClose ? 'display: none;' : ''">
              <div class="table-line---title" ref="table-line---title" :class="{ 'close-box': list.close }" :data-index="index" v-for="(list, index) in taskList.arch" :key="list.id">
                <div class="task-name" ref="task-name" :style="{ 'width': lineBox.width + 'px' }">
                  <div class="task-name-in" ref="task-name-in" :data-id="list.id" :data-index="index" :style="{ 'width': lineBox.width + 'px' }">
                    <el-tooltip class="task-name-fo" effect="dark" :content="list.check ? '取消全选': '全选'" placement="top" v-if="isCheckStatus && list.tasks.length > 0">
                      <el-checkbox class="fo-all-check--checkbox"  :indeterminate="list.indeterminate" :value="list.check" @change="checkBoxChange(list, list.tasks)"></el-checkbox>
                    </el-tooltip>
                    <div class="up-arrow" :style="{ visibility: list.archived_parent_task_count > 0 ? 'visible' : 'hidden', 'marginLeft': '30px' }" @click="closeItem(index, 'arch')">
                      <i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': !list.close}"></i>
                    </div>
                    <div class="taskList-title">
                      <toolTip :title="list.title" :maxWidth="'calc(100% - 60px)'">
                        <span>{{ list.title }}</span>
                      </toolTip>
                      <div class="count">{{list.archived_parent_task_count}}</div>
                    </div>
                    <div class="tasklist-title-right" v-if="!ganttType">
                      <div class="icon-heand-tool" v-if="!list.isTitleEdit">
                        <el-dropdown trigger="click"  @visible-change="changeListShow(list)" v-if="hasPermission && !list.isTitleEdit && !isCheckStatus && !isDisabledProject">
                          <i
                          class="icon iconfont iconicon_more_task1 tableIconHover more-icon"
                          :class="{'visibleActive': list.titleShow}"
                          ></i>
                          <el-dropdown-menu slot="dropdown" :offset="0" class="tasklist-title-more">
                            <el-dropdown-item @click.native="delGroup(list)">
                              <i class="icon iconfont iconicon_recycle_bin"></i>
                              <span>移至回收站</span>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
                <TrList :list="list.tasks" :lineBox="lineBox" :pageMsg="pageMsg" :group="list.task_list_id" :taskList="taskList.arch" :activeId="activeId" :autoKey="autoKey" :projectId="projectId" :sortList="sortList" :templateKey="templateKey" @check="check(list.tasks, list)" :headerWidth="followHeadWidth"></TrList>
              </div>
            </div>
          </div>
          <div class="loading-box" v-if="!isFinish && !taskList.archClose">
            <i class="el-icon-loading"></i>
            <span>载入中...</span>
          </div>
        </div>
      </div>
      <div v-if="(taskList.unArch.length > 0 || taskList.arch.length > 0) && autoKey" :style="{width: `calc(100% - ${lineBox.width}px)`, left: lineBox.width + 'px'}" class="table-bottom-line" ref="table-bottom-line" @scroll="addListenerLine($event)">
        <div class="table-bottom-line-conttent" ref="table-bottom-line-conttent" :style="{'width': followHeadWidth - lineBox.width - 1 + 'px'}"></div>
      </div>
      <RightLine v-if="taskList.unArch.length > 0 || taskList.arch.length > 0" :left="lineBox.width" :disabled="moveCell" @moveCompete="moveCompete"></RightLine>
      <nothing v-if="!loading && taskList.unArch.length === 0 && taskList.arch.length === 0" :config="{ tip: '暂无任务清单', btnText: hasPermission && !isDisabledProject ? '新建任务清单' : '', type: 'img_no_data' }"   @button-click="addChecklist"></nothing>
    </div>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable'
import TrList from './tr'
import { mapActions, mapMutations, mapState } from 'vuex'
import elementResizeDetectorMaker from 'element-resize-detector'
import api from "@/services/api/task/task";
import conApi from '@/services/api/connect/connect'
import bus from '@/bus'
import AddTaskGroup from '../addTaskGroup'
import TableModeCount from "../../tableModeCount";
import RightLine from './rightLine'
import VueSticky  from 'vue-sticky';

let elementObj = elementResizeDetectorMaker()
export default {
  props: {
    autoKey: {
      type: Boolean,
      default: true
    },
    projectId: [String, Number]
  },
  components: {
    vuedraggable,
    TrList,
    AddTaskGroup,
    TableModeCount,
    RightLine
  },
  data() {
    let _this = this
    return {
      loading: false,
      isFinish: false,
      limit: 20,
      sortList: [],
      pageMsg: {
        offset: 0,
        limit: 20,
        project_id: _this.projectId,
        task_stage: '全部',
      },
      taskList: {
        unArchClose: false,
        archClose: false,
        unArch:[],
        arch: []
      },
      viewsBlock: [],
      shiftDown: false,
      viewScorllLeft: 0, // 当前左侧滚动距离
      moveCell: '', // 当前移动中的列
      lineWidth: '',
      headLineMove:0,
      headerWidth: 0,
      lineBox: {
        width: 426,
        key: 'task_name',
        title: '任务标题'
      },
      taskListId: null, //编辑任务标题的所在任务id
      projectName: '', //编辑任务标题的所在任务的任务标题
      activeId:'',
      countAllTable: 0,
      tableOnlyTitle: {},
      inputTitle: '',
      timer: null,
      list_id_type: 'task_list_id',
    }
  },
  computed: {
    ...mapState("customKey/customKey", {
      templateKey: (state) => {
        return state.templateList.filter(res => res.is_show)
      },
    }),
    ...mapState('task/task', {
      queryMsg: state => state.queryMsg,
      isCheckStatus: state => state.isCheckStatus,
      checkBox: state => state.checkBox,
      ganttType: state => state.ganttType,
      taskModeCheck: state => state.taskModeCheck,
      isDisabledProject: state => state.isDisabledProject
    }),
    hasPermission() {
      return this.isAdmin
    },
    getKeyList() {
      return (list) => {
        let item = [];
        for (let key in list) {
          if (typeof(list[key]) === 'object' && list[key] && list[key].length > 0) {
            item.push(...list[key]);
          }
        }
        return item;
      };
    },
    taskCountChildren() {
      return (data) => {
        let count = 0
        let fn = (list) => {
          for (let key in list) {
            if (typeof(list[key]) === 'object' && list[key] && list[key].length > 0) {
              count += list[key].length
              list[key].forEach(res => {
                if (res.open && res.tasks) {
                  fn(res.tasks)
                }
              })
            }
          }
        }
        fn(data)
        return count
      }
    },
    allClose() { // 是否归档与未归档都在关闭状态，则不触发loading
      return this.taskList.unArchClose && this.taskList.archClose
    },
    followHeadWidth() {
      return this.headerWidth ? this.headerWidth : this.lineBox.width
    }
  },
  watch: {
    viewScorllLeft() {
      this.$refs['table-line-head'].scrollLeft = this.viewScorllLeft
      let doms = document.getElementsByClassName('table-body')
      doms[0].scrollLeft = this.viewScorllLeft
      doms[1].scrollLeft = this.viewScorllLeft
    },
    queryMsg: {
      async handler() {
        await this.createInit()
        this.debounce(this.restData, 300)
      },
      deep: true,
      immediate: true
    },
    taskList: {
      handler() {
        this.$emit('dataChange')
      },
      deep: true
    },
    loading() {
      this.$emit('loading', this.loading)
    },
    ganttType() {
       this.list_id_type = this.ganttType ? 'executor' : 'task_list_id'
    }
  },
  directives:{
    'sticky': VueSticky,
  },
  mounted() {
    // this.createInit()
    bus.$on('addOffset', ({ groupId, task_stage }) => { // 移动到外层数量+1
      this.pageMsg.offset = this.pageMsg.offset + 1
      this.taskList.find(res => {
        if (res.id == groupId) {
          res.unarchived_parent_task_count = res.unarchived_parent_task_count + 1
          if(task_stage === '已完成') res.unarchived_completed_parent_task_count = res.unarchived_completed_parent_task_count + 1
          return true
        }
      })
    })
    bus.$on('reduceOffset', ({ groupId, task_stage }) => { // 移动到外层数量+1
      this.pageMsg.offset = this.pageMsg.offset - 1
      this.taskList.find(res => {
        if (res.id == groupId) {
          res.unarchived_parent_task_count = res.unarchived_parent_task_count - 1
          return true
        }
      })
    })
    bus.$on("selectChangeTaskHade", async ({ id, index, task_stage }) => {
      this.pageMsg.task_stage = task_stage;
      this.restData()
    })
    bus.$on('restData', () => {
      this.restData()
    })
    bus.$on('updateTask', (data) => {

      if(!data || data.isNeedReset) {
        this.restData();
      } else {
        this.updateTask(data)
      }
    })
    bus.$on('activeTr', id => { // 点击该行，保留高亮
      this.activeId = id
    })
    bus.$on('changeTableScroll', n => {
      if(this.$refs['outer-box']) {
        this.$refs['outer-box'].scrollTop = this.$refs['outer-box'].scrollTop + n
      }
    })
    bus.$on('clear_check', () => {
      this.taskList.unArch.map(res => {
        for(let key in res.tasks) {
            if (typeof(res.tasks[key]) === 'object' && res.tasks[key] && res.tasks[key].length > 0) {
              for (let i = 0; i < res.tasks[key].length; i++) {
                if(!res.tasks[key][i].check) continue
                res.tasks[key][i].check = false
              }
            }
        }
      })
      this.taskList.arch.map(res => {
        res.tasks.map(item => {
          item.check = false
        })
      })
    })
  },
  destroyed() {
    bus.$off('addOffset')
    bus.$off('reduceOffset')
    bus.$off('selectChangeTaskHade')
    bus.$off('restData')
    bus.$off('updateTask')
    bus.$off('activeTr')
  },
  methods: {
    ...mapActions("customKey/customKey", ["getprojectTemplate"]),
    ...mapActions('task/task', ['getTaskListTable','editChecklist', 'deletetasklist', 'updateorderby', 'changeTemplateListOfSort']),
    ...mapMutations('task/task',['CHANGE_TASK','set_checkTask']),
    getRealData(dataset) {
      let result = {
        unArch:[],
        arch: []
      }
      if(dataset.unarchived_tasks.length === 0 && dataset.archived_tasks.length === 0) return result
      const fn1 = () => {
        let minIdx = 0
        let maxIdx = 0
        let nowIndex = 0
        dataset.unarchived_tasks.forEach((res, index) => {
          if(!dataset.unarchived_tasks[index + 1] || res[this.list_id_type] !== dataset.unarchived_tasks[index + 1][this.list_id_type]) {
            /**
             * 在返回的数据中顺序区分一段数据是否为一个自己所属的清单
             * 1.主要通过下标index的前后task_list_id的不同为一个区分基点
             * 2.maxIdx保存第一个坐标，当找到task_list_id和第一个坐标不同时，截取maxIdx到当前坐标作为一个清单组，并赋值maxIdx作为开始坐标
             */
            maxIdx = this.tableOnlyTitle.unarchived_task_lists.task_lists.findIndex(temp => temp.task_list_id === res[this.list_id_type]) // 记录该组清单下标
            if(nowIndex === 0) { // 从第一个清单
              minIdx = maxIdx
            }
            let tasks = dataset.unarchived_tasks.slice(nowIndex, index + 1) // 拿出这组
            if(minIdx !== maxIdx) { // 查询是否有空清单
              let nullTaskList = this.tableOnlyTitle.unarchived_task_lists.task_lists.slice(minIdx, maxIdx)
              nullTaskList.map(res => res.finish = true)
              result.unArch.push(...nullTaskList)
            }

            // 插入这组数据
            let taskObject = JSON.parse(JSON.stringify(this.tableOnlyTitle.unarchived_task_lists.task_lists[maxIdx]))
            if (this.getReadyAllTask(taskObject) === tasks.length) { // 清单是否加载完
              taskObject.finish = true;
            }
            let arrLevel = this.groupToArrayByValue(tasks).result // 任务根据优先级分组
            taskObject.tasks = arrLevel
            result.unArch.push(taskObject)
            nowIndex = index + 1
          }
          minIdx = maxIdx + 1
        })
        this.tableOnlyTitle.isFinishArch = !this.tableOnlyTitle.isFinishArch && ((this.taskList.arch.length === 0 && dataset.archived_tasks.length > 0) || this.isFinish) && !this.taskList.unArchClose
        /**
         * 加载完成判断
         * 1.未赋值isFinishArch
         * 2.当已有数据中arch（未归档列表）为空时，新请求数据有时，便判断unArch（已归档列表）加载完成
         * 3.一开始就判断全部数据加载完成（归档与未归档）
         * 4.未归档列表没有被关闭
         */
        if(this.tableOnlyTitle.isFinishArch) { // 判断加载完成时并有剩余，需要把后面的空清单加入
          let index
          if(result.unArch.length === 0) {
            /**
             * 三种情况
             * 1. 正常加载完成并且返回有余值
             * 2.返回的值正好和limit一直并且已加载完成，当时在这次请求判断不了需要再次加载为空时判断为已完成
             * 3.一开始就返回为空数据
             */
            index = this.tableOnlyTitle.unArch.findIndex(res => res.task_list_id === this.taskList?.unArch?.[this.taskList.unArch.length - 1]?.task_list_id)
          } else {
            index = this.tableOnlyTitle.unArch.findIndex(res => res.task_list_id === result.unArch[result.unArch.length - 1]?.task_list_id)
          }
          let nullTaskList = this.tableOnlyTitle.unArch.slice(index + 1, this.tableOnlyTitle.unArch.length)
          nullTaskList.map(res => res.finish = true)
          result.unArch.push(...nullTaskList)
        }
        fn2()
      }
      const fn2 = () => {
        let minIdx = 0
        let maxIdx = 0
        let nowIndex = 0
        dataset.archived_tasks.forEach((res, index) => {
          if(!dataset.archived_tasks[index + 1] || res[this.list_id_type] !== dataset.archived_tasks[index + 1][this.list_id_type]) { // 区分一组清单
            maxIdx = this.tableOnlyTitle.archived_task_lists.task_lists.findIndex(temp => temp.task_list_id === res[this.list_id_type]) // 记录该组清单下标
            if(nowIndex === 0) { // 从第一个清单
              minIdx = maxIdx
            }
            let tasks = dataset.archived_tasks.slice(nowIndex, index + 1) // 拿出这组
            // 插入这组数据
            let taskObject = this.tableOnlyTitle.archived_task_lists.task_lists[maxIdx]
            taskObject.isArch = true
            if (this.getReadyAllTask(taskObject) === tasks.length) { // 是否加载完
              taskObject.finish = true;
            }
            // let arrLevel = this.groupToArrayByValue(tasks).result // 任务根据优先级分组
            taskObject.tasks = tasks
            result.arch.push(taskObject)
            nowIndex = index + 1
          }
          minIdx = maxIdx + 1
        })
      }
      fn1()
      return result
    },
    groupToArrayByValue(arrData) {
      // 需求当有排序设置时（this.queryMsg.sorting_rules）并且已生效时不根据优先级排布
      if(this.queryMsg.sorting_rules && this.queryMsg.sorting_rules.length > 0 && this.queryMsg.sort_switch === 1) {
        let result = {
          task: [],
          compete: []
        }
        let count = 0;
        arrData.forEach((item) => {
          count += item.unread_message_count > 0 ? 1 : 0;
          result.isTitleEdit = false;
          if(item.task_stage === '已完成') {
            result.compete.push(item)
          } else {
            result.task.push(item)
          }
        });
        return { result, count };
      } else {
        let result = {
          level4: [],
          level3: [],
          level2: [],
          level1: [],
          compete: []
        }
        let count = 0;
        arrData.forEach((item) => {
          count += item.unread_message_count > 0 ? 1 : 0;
          result.isTitleEdit = false;
          if(item.task_stage === '已完成') {
            result.compete.push(item)
          } else {
            result["level" + item.sort_rule.sort] ? result["level" + item.sort_rule.sort].push(item) : (result["level" + item.sort_rule.sort] = [item]);
          }
        });
        return { result, count };
      }
    },
    async createInit() {
      this.loading = true
      // await this.taskListToSimpleIndex()
      await this.getTaskSortList()
      await this.getTemplateDetail();
      // this.init()
      this.shiftListener()
      this.windowAddMouseWheel()
    },
    updateTask(data) {
      /**
       * 更新任务
       * 1.更新任务可能为父任务或者子任务
       * 2.请求该任务详情，递归当前数据找出相同task_id并且替换掉
       */
      let { task_id, task_list_id } = data
      let tree = async (id, temp, newTask) => {
        if(Object.prototype.toString.call(temp) === '[object Object]') {
          for(let key in temp) {
            if (typeof(temp[key]) === 'object' && temp[key] && temp[key].length > 0) {
              for (let i = 0; i < temp[key].length; i++) {
                if (temp[key][i].id == id) {
                  newTask.open = temp[key][i].open
                  newTask.check = temp[key][i].check
                  if(temp[key][i].open) {
                    let queryMsg = {
                      ...this.queryMsg
                    }
                    queryMsg.sorting_rules = JSON.stringify(queryMsg.sorting_rules || [])
                    let params = {
                      page: 1,
                      number: 999,
                      parent_task_id: temp[key][i].id,
                      ...queryMsg
                    }
                    let result = await api.childrenTasksIndex(params)
                    newTask.tasks = result
                  } else {
                    newTask.tasks = temp[key][i].tasks || []
                  }
                  temp[key].splice(i, 1, {})
                  this.$nextTick(() => {
                    temp[key].splice(i, 1, {...temp[key][i], ...newTask})
                  })
                  return true
                } else if (temp[key][i].tasks) {
                  tree(id, temp[key][i].tasks, newTask)
                }
              }
            }
          }
        } else {
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].id == id) {
              newTask.open = temp[i].open
              newTask.check = temp[i].check
              if(temp[i].open) {
                let queryMsg = {
                  ...this.queryMsg
                }
                queryMsg.sorting_rules = JSON.stringify(queryMsg.sorting_rules || [])
                let params = {
                  page: 1,
                  number: 999,
                  parent_task_id: temp[i].id,
                  ...queryMsg
                }
                let result = await api.childrenTasksIndex(params)
                newTask.tasks = result
              } else {
                newTask.tasks = temp[i].tasks || []
              }
              temp.splice(i, 1, {})
              this.$nextTick(() => {
                temp.splice(i, 1, {...temp[i], ...newTask})
              })
              return true
            } else if (temp[i].tasks) {
              tree(id, temp[i].tasks, newTask)
            }
          }
        }
      }
      api.getTaskDetail({ task_id }).then(task => {
        this.taskList[task.task_stage === '已归档' ? 'arch' : 'unArch'].find((res, index) => {
          if (res.task_list_id == task_list_id) {
            return Boolean(tree(task_id, res.tasks, task))
          }
        })
      })
    },
    // 清单列表获取与处理
    taskListToSimpleIndex() {
      return (this.ganttType ? api.userIndexForProjectToSimple({api_version: 'v2',project_id: this.projectId, ...this.queryMsg }) : this.getTaskListTable({ project_id: this.projectId,...this.queryMsg })).then((res) => {
        res.unarchived_task_lists = res.unarchived_task_lists || res.archived_task_users
        res.unarchived_task_lists.task_lists = res.unarchived_task_lists.task_lists || res.unarchived_task_lists.users
        if(this.queryMsg.task_list_ids && this.queryMsg.task_list_ids.length > 0) {
          res.unarchived_task_lists.task_lists = res.unarchived_task_lists.task_lists.filter(res => this.queryMsg.task_list_ids.indexOf(res.task_list_id) > -1)
          res.archived_task_lists.task_lists = res.archived_task_lists.task_lists.filter(res => this.queryMsg.task_list_ids.indexOf(res.task_list_id) > -1)
        }
        res.unarchived_task_lists.task_lists.map((temp) => {
          temp.finish = false;
          temp.close = false;
          temp.isTitleEdit = false;
          temp.title = temp.title || temp.realname
          temp.task_list_id = temp.task_list_id || temp.uid
          temp.tasks = []
          temp.tasks = this.groupToArrayByValue(temp.tasks).result
        });
        res.archived_task_lists = res.archived_task_lists || res.unarchived_task_users
        res.archived_task_lists.task_lists = res.archived_task_lists.task_lists || res.archived_task_lists.users
        res.archived_task_lists.task_lists.map((temp) => {
          temp.finish = false
          temp.close = false
          temp.isTitleEdit = false
          temp.title = temp.title || temp.realname
          temp.task_list_id = temp.task_list_id || temp.uid
          temp.tasks = []
        });
        res.unArch = res.unarchived_task_lists.task_lists
        res.arch = res.archived_task_lists.task_lists
        bus.$emit("filterTitleData", JSON.parse(JSON.stringify(res.unarchived_task_lists.task_lists)) || [])
        this.tableOnlyTitle = res
      });
    },
    getTaskSortList() {
      return api.getTaskSortList({ sort_rule_type_id: 1 }).then((res) => {
        this.sortList = res.reverse();
      });
    },
    tileData(dataList) {
      let arr = [];
      dataList.forEach((item) => {
        arr = [...arr, ...item.member];
      });
      return arr;
    },
    getTemplateDetail() {
      let params = {
        number: 991,
        page: 1,
        project_id: this.projectId,
      };
      return this.getprojectTemplate(params);
    },
    async addSuccess(task_list_id, id, pid) {
      if(this.queryMsg.status_filter === 2 || this.queryMsg.status_filter === 4) return
      let fn = async (data) => {
        for(let key in data) {
            if (typeof(data[key]) === 'object' && data[key] && data[key].length > 0) {
              for (let i = 0; i < data[key].length; i++) {
                if(data[key][i].id === pid) {
                  data[key][i].all_children_task_count !== undefined ? this.$set(data[key][i],'all_children_task_count', data[key][i].all_children_task_count * 1 + 1)  : ''
                  if(data[key][i].open) { // 获取该父任务的子任务
                    let queryMsg = {
                      ...this.queryMsg
                    }
                    queryMsg.sorting_rules = JSON.stringify(queryMsg.sorting_rules || [])
                    let params = {
                      offset: 0,
                      limit: 100,
                      parent_task_id: pid,
                      task_stage: this.pageMsg.task_stage,
                      ...queryMsg
                    }
                    let result = await api.childrenTasksIndex(params)
                    this.$set(data[key][i], 'tasks', this.groupToArrayByValue(result.data).result)
                  }
                  return data[key][i]
                }
                if(data[key][i].tasks) {
                  fn(data[key][i].tasks)
                }
              }
            }
        }
      }
      this.taskList.unArch.find(res => {
        if(res.task_list_id === task_list_id) {
          if(pid) {
            fn(res.tasks, pid)
          } else {
            api.getTaskDetail({ task_id: id }).then(result => {
              // 如果排序规则有值并生效
              if (this.queryMsg.sorting_rules && this.queryMsg.sorting_rules.length > 0 && this.queryMsg.sort_switch === 1) {
                res.tasks.task.push(result)
                res.unarchived_parent_task_count = res.unarchived_parent_task_count + 1
                this.pageMsg.offset = this.pageMsg.offset + 1
                return
              }
               for(let key in res.tasks) {
                 if (key === `level${result.sort_rule.sort}`) {
                  console.log('4')
                   res.tasks[key].unshift(result)
                   res.unarchived_parent_task_count = res.unarchived_parent_task_count + 1
                   this.pageMsg.offset = this.pageMsg.offset + 1
                   return
                 }
               }
             })
          }
          return true
        }
      })
    },
    concatArr(item, arr) {
      for (let key in item) {
        if (item[key]) {
          item[key].push(...arr[key]);
        }
        // item[key] = arr[key]
      }
      return item;
    },
    mergeUnOrArch(key, res) { //  合并清单
      // 合并未归档
      if(!res[key][0]) return
      let starIndex = this.taskList[key].length - 1 < 0 ? 0 : this.taskList[key].length - 1
      let endIndex = this.tableOnlyTitle[key].findIndex(temp => temp.task_list_id === res[key][0].task_list_id)
      if(starIndex === endIndex && this.taskList[key][starIndex]) { // 头尾相同合并
        key === 'arch' ? this.taskList[key][starIndex].tasks.push(...res[key][0].tasks) : this.concatArr(this.taskList[key][starIndex].tasks, res[key][0].tasks);
        res[key].splice(0,1)
      }
      this.taskList[key].push(...res[key])
    },
    initHeadMerge(res) {
      // 正常检查从头是否有空清单，则显示空清单
      let task_list_id = res.unArch[0] ? res.unArch[0].task_list_id : ''
      let endIndex = this.tableOnlyTitle.unArch.findIndex(temp => temp.task_list_id === task_list_id)
       if(endIndex > 0) {
        let nullTaskList =  this.tableOnlyTitle.unArch.slice(0, endIndex)
        nullTaskList.map(res => res.finish = true)
        this.taskList.unArch.push(...nullTaskList)
      } else if(endIndex < 0 && this.taskList.unArch.length === 0) { // 初始化返回为空，展示所有清单
        this.taskList.unArch.push(...this.tableOnlyTitle.unArch)
      }
    },
    async init() {
      this.loading = true
      let result = await this.getTaskAllIndex()
      // 找出头的空清单
      this.initHeadMerge(result) // unArch 首次请求遍历空清单
      this.mergeUnOrArch('unArch', result)
      this.mergeUnOrArch('arch', result)
      this.$nextTick(() => {
        this.createScroll();
        this.isLoaidng = false;
      })
      this.loading = false
    },
    dragOptionsList() {
      return {
        animation: 200,
        group: 'listTask',
        disabled: false
      }
    },
    moveCompete(val) {
      this.$set(this.lineBox,'width',val)
    },
    addListenerScroll(e) {
      let scrollTop = e.target.scrollTop
      bus.$emit('ganttMapScrollChange', scrollTop)
      this.scrollTop = scrollTop
      let oHeight = document.getElementsByClassName('outer-box')[0].offsetHeight
      let content = this.$refs['taskSuper-table'].offsetHeight
      if (!this.isLoaidng && content - scrollTop < oHeight * 2) {
        this.pageMsg.offset = this.pageMsg.offset + this.limit
        this.loadNextPage()
      }
    },
    closeItem(index, key) {
      this.$set(this.taskList[key][index], 'close', !this.taskList[key][index].close)
      this.closeTaskList(this.taskList[key][index]) // 清单关闭，展示清单进度
      this.$nextTick(() => {
        let parentBox = document.getElementsByClassName("outer-box")[0].offsetHeight;
        let scrollTop = document.getElementsByClassName("outer-box")[0].scrollTop;
        let box = this.$refs["taskSuper-table"].offsetHeight;
        let screen = box - scrollTop
        if (!this.taskList[key][index].close && !this.taskList[key][index].finish) { // 展开时
          this.isLoaidng = false;
          this.isFinish = false;
          if(key === 'unArch') {
            let realHas = this.getKeyList(this.taskList[key][index].tasks).length
            this.pageMsg.offset = this.taskList[key].slice(0, index).reduce((pre, n) => pre + this.getReadyAllTask(n), 0) + realHas
            this.taskList[key].splice(index + 1);
            this.taskList.arch = []
            this.pageMsg.offset = this.pageMsg.offset;
          } else {
            let realHas = this.taskList[key][index].tasks.length
            let offset = this.taskList.unArch.reduce((pre, n) => pre + this.getReadyAllTask(n), 0)
            this.pageMsg.offset  = this.taskList[key].slice(0, index).reduce((pre, n) => pre + this.getReadyAllTask(n), 0) + offset + realHas
            this.taskList[key].splice(index + 1);
            this.pageMsg.offset = this.pageMsg.offset;
          }
          this.loadNextPage(); // 需要删除上一个空白清单在往下加载
        } else if (!this.taskList[key][index].finish && (box < parentBox || screen <= parentBox)) { // 收起清单
          // 任务缩小加载下一个清单
          // this.pageMsg.offset = this.taskList[key].slice(0, index).reduce((pre, n) => pre + this.getReadyAllTask(n), 0) + this.getReadyAllTask(this.taskList[key][index]);
          if(key === 'unArch') {
            let offset = this.taskList[key].slice(0, index).reduce((pre, n) => pre + this.getReadyAllTask(n), 0) + this.getReadyAllTask(this.taskList[key][index]);
            this.pageMsg.offset = offset
          } else {
            let offset = this.taskList.unArch.reduce((pre, n) => pre + this.getReadyAllTask(n), 0) // 已归档个数
            +
            this.taskList[key].slice(0, index).reduce((pre, n) => pre + this.getReadyAllTask(n), 0) // 已归档部分个数
            +
            this.getReadyAllTask(this.taskList[key][index]) // 当前收起的清单
            this.pageMsg.offset  = offset
          }
          this.loadNextPage(index);
        } else if (!this.isFinish && box < parentBox) {
          // 当出现空白顺序加载
          this.pageMsg.offset = this.pageMsg.offset + this.limit;
          this.loadNextPage();
        }
      })
    },
    async closeTaskList(item) {
      if(this.ganttType || this.taskModeCheck.components !== 'Gantt') return
      if(item.close) {
        let result = await conApi.getListTotalProgress({ task_list_id: item.task_list_id })
        this.$set(item, 'closeData', result)
      }
    },
    getTaskAllIndex() {
      return new Promise((resolve, reject) => {
        let queryMsg = {
          ...this.queryMsg
        }
        queryMsg.sorting_rules = JSON.stringify(queryMsg.sorting_rules || [])
        api.projectTaskIndex({ ...this.pageMsg,...queryMsg, api_version: this.autoKey ? 'v3' : 'v2'}).then(res => {
          if(res.unarchived_tasks.length + res.archived_tasks.length < this.limit) { // 判断小于limit， 不能判断等于，因为存在还有数据未加载情况
            this.isFinish = true
          }
          resolve(JSON.parse(JSON.stringify(this.getRealData(res))))
        })
      })
    },
    async loadNextInTask(index) {
      if (this.isFinish || this.isLoaidng || this.allClose) {
        return
      }
      this.isLoaidng = true;
      let result = await this.getTaskAllIndex()
      if (result.length === 0) {
          this.isFinish = true;
          return
        } else if (result.reduce((pre, n) => pre + n.tasks.length, 0) < this.limit) {
          this.isFinish = true;
        } else {
          this.isFinish = false;
        }
        result.map((item) => {
          if (this.getReadyAllTask(item) === item.tasks.length) {
            item.finish = true
          }
          if (!item.close) {
            item.close = false
          }
          item.isTitleEdit = false
        });
        this.taskList.splice(index + 1, this.taskList.length - 1, ...result);
        this.isLoaidng = false
      this.isLoaidng = false
    },
    async loadNextPage() {
      if (this.isFinish || this.isLoaidng || this.allClose) {
        return
      }
      this.isLoaidng = true
      let result = await this.getTaskAllIndex()
      this.mergeUnOrArch('unArch', result)
      this.mergeUnOrArch('arch', result)
      this.$nextTick(() => {
        this.isLoaidng = false
        this.loading = false
        this.$refs["outer-box"].scrollTop = this.scrollTop
      });
    },
    getReadyAllTask(item) {
      if(item.isArch) {
        return item.archived_parent_task_count
      } else {
        return item.unarchived_parent_task_count
      }
      // if (this.pageMsg.task_stage === "全部") {
      //   return item.unarchived_parent_task_count * 1
      // } else if (this.pageMsg.task_stage === "已完成") {
      //   return item.unarchived_completed_parent_task_count * 1
      // } else {
      //   return item.unarchived_parent_task_count * 1 - item.unarchived_completed_parent_task_count * 1
      // }
    },
    shiftListener() {
      document.onkeydown = (e) => {
        if (e.keyCode === 16) {
          this.shiftDown = true
        }
      }
      document.onkeyup = (e) => {
        if (e.keyCode === 16) {
          this.shiftDown = false
        }
      }
    },
    windowAddMouseWheel() {
      var scrollFunc = (e) => {
        if (!this.shiftDown) return
        e = e || window.event
        e.preventDefault()
        e.stopPropagation()
        let value = ''
        let n = -1
        if (e.wheelDelta) {
          //判断浏览器IE，谷歌滑轮事件
          value = e.wheelDelta
          value > 0 ? (n = -1) : (n = 1)
        } else if (e.detail) {
          //Firefox滑轮事件
          value = e.detail
          value > 0 ? (n = 1) : (n = -1)
        }
        let seep = 2
        let timer = setInterval(() => {
          if (seep >= 14) {
            clearInterval(timer)
            return
          }
          let left = this.$refs['table-bottom-line'].scrollLeft
          this.$refs['table-bottom-line'].scrollLeft = left + seep * n
          seep = seep + 2
        }, 20)
      }
      //给页面绑定滑轮滚动事件
      let ele = this.$refs['fixed-box']
      if (ele && ele.addEventListener) {
        ele.addEventListener('DOMMouseScroll', scrollFunc, false)
        //滚动滑轮触发scrollFunc方法
        ele.onmousewheel = scrollFunc
      }
    },
    createScroll() {
      let headD = this.$refs['table-line-head-in']
      if (headD) {
        elementObj.listenTo(headD, async (ele) => {
          this.headerWidth = ele.offsetWidth
        })
      }
    },
    async endList(e) {
      // let previous_id = e.newIndex - 1 < 0 ? 0 : this.taskList[e.newIndex - 1].id
      // let next_id = e.newIndex + 2 > this.taskList.length ? 0 : this.taskList[e.newIndex + 1].id
      // let id = this.taskList[e.newIndex].id
      // let params = {
      //   id,
      //   previous_id,
      //   next_id
      // }
      // api.updateorderby(params)
      let temp = this.taskList.unArch.map((item, index) => {
        return {
          task_list_id: item.task_list_id,
          orderby: index,
        };
      });
      await this.updateorderby({ project_id: this.projectId, list: temp })
      this.$message({
        message: "修改成功",
        type: "success",
      });
    },
    addListenerLine(e) {
      this.viewScorllLeft = e.target.scrollLeft
    },
    addTask(item) {
      let { task_list_id} = item
      bus.$emit('addTask', {task_list_id, id: 0})
    },
    restData() {
      this.dataInit()
    },
    async dataInit() {
      this.tableOnlyTitle = {}
      await this.taskListToSimpleIndex()
      this.isFinish = false
      this.isLoaidng = true
      this.loading = true
      this.pageMsg.offset = 0
      this.pageMsg.limit = this.limit
      this.shiftDown = false
      this.$refs["table-bottom-line"] ? this.$refs["table-bottom-line"].scrollLeft = 0 : ''
      this.taskList = {
        unArch:[],
        arch: [],
        unArchClose: false,
        archClose: false,
      }
      this.$nextTick(() => {
        this.init()
      })
    },
    addTaskListSuccess(name,result) {
      this.$message({
        message: name ? '编辑名称成功' : '新增分组成功',
        type: 'success'
      })
      if (name) {
        this.taskList.find(res => {
          if (res.id === this.taskListId) {
            res.title = name
            return true
          }
        })
      } else {
        let data = {
          close: true,
          finish: true,
          isTitleEdit: false,
          id: Number(result.id),
          unarchived_completed_parent_task_count:0,
          unarchived_parent_task_count:0,
          title: result.title,
          tasks:[]
        }
        this.taskList.push(data)
      }
    },
    async delGroup(item) {
       await this.$wfAlert('warning', '确定删除该清单？', '清单删除后不可恢复，请谨慎操作。','确认删除')
       await this.deletetasklist({task_list_id: item.task_list_id})
       let idx = this.taskList.unArch.findIndex(res => res.task_list_id === item.task_list_id)
       this.taskList.unArch.splice(idx,1)
    },
    autoKeyTrMove(e, item) {
      if (this.moveCell && this.moveCell !== item.id) return
      if (this.mouseHasIn(e)) {
        window.document.body.className = 'col-resize'
      } else if (item.mouseDown) {
        window.document.body.className = 'col-resize'
      } else {
        window.document.body.className = ''
      }
    },
    mouseHasIn(e) {
      let width = e.currentTarget.offsetWidth
      let offsetX = e.offsetX
      return offsetX > width - 8
    },
    autoKeyTrLevel(e, item) {
      if (this.moveCell && this.moveCell !== item.id) return
      if (!item.mouseDown) {
        window.document.body.className = ''
      }
    },
    autoKeyTrDown(e, item) {
      if (this.mouseHasIn(e)) {
        this.moveCell = item.id
        this.$set(item, 'mouseDown', true)
        this.$set(item, 'target', e.currentTarget)
        this.$set(item,'oldWidth', e.currentTarget.offsetWidth)
        window.document.onmousemove = (ev) => {
          let width = item.oldWidth + (ev.x - e.x)
          if (width <= 106) {
            width = 106
           }
          this.$set(item, 'width', width)
        }
      }
      window.onmouseup = () => {
        this.autoKeyTrUp(item)
        window.document.onmouseup = null
      }
    },
    autoKeyTrUp(item) {
      this.$set(item, 'mouseDown', false)
      this.moveCell = ''
      window.document.onmousemove = ''
      window.document.body.className = ''
    },
    forDelTask(tree, id, parentVal) {
      tree = Array.isArray(tree) ? tree : [tree]
      for (let i = 0, len = tree.length; i < len; i++) {
        if (tree[i].id == id) {
          if(parentVal.pid === undefined){
            parentVal.unarchived_parent_task_count = parentVal.unarchived_parent_task_count  - 1 // 分组减一
            this.pageMsg.offset = this.pageMsg.offset - 1
          }else {
            parentVal.number_of_next_level_tasks = parentVal.number_of_next_level_tasks  - 1 // 父任务减一
          }
          tree.splice(i,1)
          return tree[i]
        }
        if (tree[i].tasks) {
          return this.forDelTask(tree[i].tasks, id, tree[i])
        }
      }
    },
    addChecklist() {
      this.$emit("addTaskList")
    },
    async updateTaskChange(id, val) {
      let result = await api.getTaskDetail({id})
      this.getPathById(this.taskList, id, result, val)
    },
    async getPathById(tree, id, result, val, parentVal) {
      // tree = Array.isArray(tree) ? tree : [tree]
      for (let i = 0, len = tree.length; i < len; i++) {
        if (tree[i].id == id) {
          if (val !== undefined && val) {
            parentVal.number_of_next_level_completed_tasks !== undefined ? this.$set(parentVal, 'number_of_next_level_completed_tasks', parentVal.number_of_next_level_completed_tasks * 1 + 1) : ''
            parentVal.unarchived_completed_parent_task_count !== undefined ? this.$set(parentVal,'unarchived_completed_parent_task_count', parentVal.unarchived_completed_parent_task_count * 1 + 1)  : ''
          } else if(val !== undefined) {
            parentVal.number_of_next_level_completed_tasks !== undefined ? this.$set(parentVal, 'number_of_next_level_completed_tasks', parentVal.number_of_next_level_completed_tasks * 1 - 1) : ''
            parentVal.unarchived_completed_parent_task_count !== undefined ? this.$set(parentVal,'unarchived_completed_parent_task_count', parentVal.unarchived_completed_parent_task_count * 1 - 1)  : ''
          }
          if(parentVal.tasks[i].pid !== undefined && parentVal.tasks[i].open) {
            result.tasks = parentVal.tasks[i].tasks
            result.open = true
          }
          this.$set(parentVal.tasks, i, result)
          return tree[i]
        }
        if (tree[i].tasks) {
          this.getPathById(tree[i].tasks, id, result, val, tree[i])
        }
      }
    },
    childrenAddTask(pid) {
      let fn = (tree, id) => {
        for (let i = 0, len = tree.length; i < len; i++) {
          if (tree[i].id == id) {
            tree[i].number_of_next_level_tasks !== undefined ? this.$set(tree[i],'number_of_next_level_tasks', tree[i].number_of_next_level_tasks * 1 + 1)  : ''
            if(tree[i].open) { // 获取该父任务的子任务
              let params = {
                number: 99,
                page: 1,
                parent_task_id: pid,
                task_stage: this.pageMsg.task_stage
              }
              let queryMsg = {
                ...this.queryMsg
              }
              queryMsg.sorting_rules = JSON.stringify(queryMsg.sorting_rules || [])
              api.childrenTasksIndex(params,...queryMsg).then(res => {
                this.$set(tree[i], 'tasks', res)
              })
            }
            return tree[i]
          }
          if (tree[i].tasks) {
            fn(tree[i].tasks, id)
          }
        }
      }
      fn(this.taskList, pid)
    },
    changeListShow(list) {
      this.$set(list, 'titleShow', !list.titleShow)
    },
    closeArchOrClose(flag) {
      switch(flag) {
        case 'unArch':
          this.taskList.unArchClose = !this.taskList.unArchClose
          if(!this.tableOnlyTitle.isFinishArch) { // 未归档任务没有加载完
            if(this.taskList.unArchClose) { // 关闭
              let offset = this.tableOnlyTitle.unArch.reduce((pre, n) => pre + this.getReadyAllTask(n), 0)
              this.pageMsg.offset = offset
              this.loadNextPage()
            } else { // 打开
              let offset = this.taskList.unArch.reduce((pre,n) => pre + this.getKeyList(n.tasks).length,0)
              this.pageMsg.offset = offset - this.limit || 0
              this.isFinish = false
              this.taskList.arch = []
              this.taskList.archClose = false
            }
          }
          break
        case 'arch':
          this.taskList.archClose = !this.taskList.archClose
          break
      }
    },
    editTitle(list, ref) {
      if ((!this.isAdmin && !this.isCheckStatus) || this.ganttType || this.isCheckStatus || this.isDisabledProject) {
        return;
      }
      this.$set(list, 'isTitleEdit', true)
      this.inputTitle = list.title;
      this.$nextTick(() => {
        this.$refs[ref][0].focus()
      })
    },
    async changeTitle(item) {
      try {
        await this.editChecklist({
          task_list_id: item.task_list_id,
          title: item.title,
        })
      } catch (error) {
      }
      item.isTitleEdit = false;
      this.restData()
    },
    enterTitleChange(ref) {
      this.$refs[ref][0].blur()
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    checkBoxChange(item, list) {
      if(item.check) { // 取消全选
        list.forEach(res => {
          if(res.check) {
            this.set_checkTask(res.id)
          }
          this.$set(res, 'check', false)
        })
        this.$set(item, `indeterminate`, false)
        this.$set(item, 'check', false)
      } else { // 全选
        list.forEach(res => {
          if(!res.check) {
            this.set_checkTask(res.id)
          }
          this.$set(res, 'check', true)
        })
        this.$set(item, `indeterminate`, false)
        this.$set(item, 'check', true)
      }
    },
    check(dataset, list) {
      if(!dataset || dataset.length === 0) return
      if(dataset.every(res => res.check)) {
        this.$set(list, `indeterminate`, false)
        this.$set(list, `check`, true)
      } else if(dataset.some(res => res.check)) {
        this.$set(list, `check`, false)
        this.$set(list, `indeterminate`, true)
      } else {
        this.$set(list, `check`, false)
        this.$set(list, `indeterminate`, false)
      }
    },
    // 排序选中
    selectSort(name, value) {
      let sorting_rules = this.queryMsg.sorting_rules
      sorting_rules.map(res => {
        if(res[name]) {
          res[name] = value
        }
      })
      this.changeTemplateListOfSort({sorting_rules, sort_switch: this.queryMsg.sort_switch})
    },
    setWidth() {

    }
  }
}
</script>
<style lang="scss">

.table-select-box-longtext {
  padding: 0;
  // 短文本
  .el-textarea {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    textarea {
      width: 100%;
      height: 100%;
      padding: 0;
      border-radius: 0 !important;
    }
  }
  .el-textarea__inner {
    border-radius: 0 !important;
  }
}

.col-resize {
  cursor: col-resize !important;
  user-select: none;
}

.table-fixed-box {
  position: relative;
  // overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  .table-sort-down {
    font-size: 14px;
    margin-left: 2px;
    display: flex;
    align-items: center;
    .el-dropdown {
      height: 22px;
      line-height: initial;
    }
    i {
       color: rgba(32, 32, 32, 0.60);
    }
  }
  .table-line-content .table-body .table-line---title > .task-list-curr .table-line---tr .table-line---item{
    border-bottom: 1px solid #e7e8ed99;
  }
  .table-line-content .table-body .table-line---title {
    .task-name + .task-list-curr div:first-child .table-line---tr .table-line---item {
      border-top: 1px solid #e7e8ed99;
    }
  }
  .table-line-content{
      .table-body >div {
        .table-line---title:first-child {
          .task-name-in{
            border-top: 0 none;
          }
          &>.task-children-box >.task-list-curr >div:first-child >.table-line---tr{
            .table-line---item{
              border-top: 0 none;
            }
          }
        }
      }
    }
  .fo-header  {
    height: 50px;
    line-height: 50px;
    display: flex;
    background-color: #fff;
    border-bottom: 1px solid #e7e8ed99;
    box-sizing: border-box;
    margin-right: 2px;
    &.arch .fo-header-in {
      border-right: 1px solid #e7e8ed99;
    }
    .up-arrow {
      width: 22px;
      cursor: pointer;
      margin-right: 8px;
      i {
        font-size: 12px;
        color: rgba(32, 32, 32, 0.24);
        // margin-right: 16px;
        line-height: 1;
      }
    }
  }
  .fo-header-in {
    display: flex;
    align-items: center;
    color: rgba(32, 32, 32, 0.6);
    font-size: 14px;
    padding: 0 8px;
    padding-left: 18px;
  }
  .outer-box {
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    overflow: overlay;
    position: relative;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    box-shadow: 3px 0px 12px 3px rgba(13, 31, 60, 0.16);
    .check-box {
      position: absolute;
      background: rgba(38,130,255,0.08);
      border-radius: 2px;
      // border: 1px solid #2682FF;
      background-color: #2682FF;
      left: 0;
      z-index: 1001;
      height: 1px;
      min-width: 100%;
    }
    &::-webkit-scrollbar {
        display: none;
    }
    /*隐限Firefox浏览器的滚动条*/
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .fixed-box-list {
    position: relative;
    // overflow: hidden;
    height: 0;
    flex: 1;
    z-index: 1;
    box-sizing: border-box;
    .is-auto-key {
      display: flex;
      flex: 1;
      min-width: 160px;
      padding-right: 24px;
    }
    .table-line-item---title {
      cursor: pointer;
      display: flex;
      width: 0;
      flex: 1;
      padding-right: 4px;
      box-sizing: border-box;
      .count {
        flex-shrink: 0;
      }
    }

    .table-bottom-line {
      overflow: auto;
      z-index: 994;
      position: absolute;
      height: 25px;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1002;
      &::-webkit-scrollbar {
          height: 24px;
          background-color: #EEEEEE;
      }
      &::-webkit-scrollbar-thumb {
          border-radius: 0;
          background-color: rgba(32,32,32,0.08);
          &:active, &:hover {
            background-color: #9199A7;
          }
      }
      &::-webkit-scrollbar-track-piece {
          background-color: transparent;
      }
      .table-bottom-line-conttent {
        height: 100%;
      }
    }
    .taskSuper-table {
      // overflow: hidden;
      position: static !important;
      display: inline;
      div {
        box-sizing: border-box;
      }
      .task-list-curr {
        min-height: 1px;
        .task-drag-box-icon {
          width: 22px;
          margin-right: 8px;
          flex-shrink: 0;
          display: block;
          box-sizing: content-box;
          position: absolute;
          left: 36px;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }
    .table-line-item---in {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      .table-line-item---title {
        color:#202028;
      }
      span {
        cursor: pointer;
      }
      .dot {
        background: linear-gradient(225deg, #6b97cf 0%, #456fb3 100%);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 19px;
        margin-left: 19px;
        flex-shrink: 0;
      }
    }
    .table-line---tr .table-line-item---in--fixed {
      position: absolute;
      left: 0;
      z-index: 1000;
    }
    .table-line-item---in--not {
      flex: initial !important;
      flex-shrink: 0 !important;
    }
    .table-line-head {
      height: 50px;
      background-color: #fff;
      overflow: hidden;
      width: 100%;
      .table-line-head-in{
        display: inline-flex;
        height: 100%;
        min-width: 100%;
      }
      .table-line-tr:first-child {
        width: 300px;
      }
      .table-line-tr {
        box-sizing: border-box;
        height: 100%;
        font-size: 14px;
        color: rgba(32, 32, 32, 0.6);
        flex-shrink: 0;
        line-height: 50px;
        padding-left: 24px;
        border-right: 1px solid #e7e8ed99;
        border-bottom: 1px solid #e7e8ed99;
      }
    }
    .task-name-in {
      position: absolute;
      left: 0;
      background-color: #fff;
      padding: 0 8px;
      border-right: 1px solid #e7e8ed99;
      box-sizing: border-box;
      z-index:1;
      .task-name-fo {
        position: absolute;
        top: 50%;
        left: 13px;
        transform: translate(0, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:hover {
        .tasklist-title-right {
          i {
            visibility: visible;
          }
        }
        .drag-icon{
          visibility: visible;
        }
        background-color: #F6F6F6 !important;
      }
      i{
        line-height: 1;
        color: rgba(32, 32, 32, 0.6);
      }
    }
    .count {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      margin-left: 8px;
      flex-shrink: 0;
      font-weight: normal;
    }
    .task-name,
    .task-name-in {
      height: 50px;
      line-height: 50px;
      width: 426px;
      display: flex;

      .taskList-title,.title-input {
        color: #202028;;
        font-size: 14px;
        font-weight: bold;
        flex: 1;
        display: flex;
        align-items: flex-end;
        width: 0;
        cursor: pointer;
        .tool-tip {
          margin-right: 8px;
        }
      }
      .title-input {
        padding-right: 16px;
        width: 0;
        flex: 1;
      }
      .tasklist-title-right {
        display: flex;
        align-items: center;
        height: 100%;
        .more-icon{
          visibility: hidden;
        }
        i {
          line-height: 1;
          font-size: 14px;
        }
        .icon-heand-tool{
          margin-right: 4px;
          line-height: 1;
          min-width: 22px;
        }
      }
      .drag-icon {
        display: inline-block;
        text-align: center;
        font-size: 14px;
        color: rgba(32, 32, 32, 0.4);
        visibility: hidden;
        cursor: pointer;
        flex-shrink: 0;
      }
      .group-drag-box-icon {
        min-width: 30px;
      }
      .up-arrow {
        width: 22px;
        margin-right: 8px;
        cursor: pointer;
        i {
          font-size: 12px;
          color: rgba(32, 32, 32, 0.24);
          // margin-right: 16px;
          line-height: 1;
        }
      }
      .add-icon {
        visibility: hidden;
        font-size: 14px;
        flex-shrink: 0;
      }
    }
    .table-line---tr {
      display: flex;
      box-sizing: border-box;
      justify-content: flex-start;
      // padding-left: 8px;
      & > div {
        background-color: #fff;
      }
    }
    .setBackColor {
      & > div {
        background-color: #f7f8f9;
      }
    }
    .table-line---item {
      min-width: 160px;
      height: 50px;
      line-height: 50px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      border-right:1px solid #e7e8ed99;
      flex: 1;
      padding:0 8px;
      position: relative;
      box-sizing: border-box;
    }
    .table-line---item-name {
      width: 300px;
      flex: initial;
      flex-shrink: 0;
    }
    .is-top-fixed {
      position: absolute;
      z-index: 1000;
      top: 0;
      left: 0;
      right: 0;
    }
    .is-top-fixed-in {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2;
      background-color: #fff;
    }
    .table-line-content{

      display: inline;
      .table-body {
        overflow: hidden;
      }
      .table-body-arch {
        padding-bottom: 24px;
      }
    }

    .table-line---title {
      .table-line---tr {
        font-size: 14px;
        transition: all 0.3s;
        display: flex;
        &:hover {
          .table-line---item {
            background-color: #F6F6F6;
          }
        }
      }
      .tr-active {
        .table-line---item {
          background-color: #EEEEEE;
        }
      }
    }
    .loading-box {
      text-align: center;
      font-size: 14px;
      height: 30px;
      line-height: 30px;
      span {
        margin-left: 10px;
      }
    }
    .complate-style ,.readonly-style{
      // .table-line---item:not(:first-child) {
      //   opacity: 0.4;
      // }
      .add-task-range-time .complate-time {
        span {
          color: rgba(32, 32, 32, 0.4) !important;
        }
        .line {
          background-color: rgba(32, 32, 32, 0.08) !important;
        }
      }
      .level-select-value {
        color: rgba(32, 32, 32, 0.4) !important;
        background-color: rgba(32, 32, 32, 0.08) !important;
      }
      .table-line---item:not(.table-line---item-name) {
        * {
          color: rgba(32, 32, 32, 0.4) !important;
        }
        .my-avatar , .attachment-item img{
          opacity: 0.4;
        }
      }
      .table-line---item:first-child .table-line-item---in > .table-line-item---title {
        color: rgba(32, 32, 32, 0.4) !important;
        .count {
          color: rgba(32, 32, 32, 0.4) !important;
        }
      }
    }
    .readonly-style {
      .table-line---item:not(.table-line---item-name) {
        background-color: #F6F6F6;
      }
      .table-line-item---in--fixed {
        background-color: #F6F6F6;
      }
    }
    .is-check-disabled {
      cursor: pointer;
    }
    .is-check .child-box .table-line---item {
      background-color: #EDF5FF !important;
    }
    .close-box {
      transition: all 0.3s;
      .task-name-in{
        border-bottom: 1px solid #e7e8ed99 !important;
      }
      .task-list-curr {
        display: none;
      }
    }
    .status-check {
      margin-right: 8px;
      opacity: 1;
    }
    .title-input {
      display: flex;
      align-items: center;
      .wf-button {
        flex-shrink: 0;
      }
    }
    .table-footer-count-box {
      height: 40px;
      width: auto;
    }
    .table-footer-count {
      display: flex;
      .table-footer-count---item:first-child {
        padding-left: 60px;
        position: absolute;
        left: 0;
        z-index: 1;
        border: 0 none;
        border-right: 1px solid #e7e8ed99;
      }
      .table-footer-count---item {
        flex-shrink: 0;
        box-sizing: border-box;
        padding-left: 24px;
        height: 40px;
        line-height: 40px;
        width: 200px;
        background-color: #fff;
        flex: 1;
        min-width: 200px;
        .task-number-val {
          font-size: 14px;
          color: rgba(32, 32, 32, 0.6);
          margin-left: 10px;
        }
        span:first-child {
          font-size: 12px;
          color: rgba(32, 32, 32, 0.6);
          margin-right: 6px;
        }
        .number-val {
          font-size: 14px;
          color: rgba(32, 32, 32, 0.6);
          font-weight: 500;
        }
      }
    }
  }
}

.reset {
  .el-dialog__body{
    padding-top:0;
  }
  .el-dialog__headerbtn {
    // top: 10px;
  }
  .el-dialog__header {
    border-bottom: none;
  }
  .el-form-item__content {
    margin-left: 0!important;
  }
  .el-dialog__title {
    // font-weight: bold;
  }
  textarea {
    background: #fff;
  }
}

</style>
